import { META_TITLES, META_DESCRIPTION } from '~/resources/news/meta'
import { useMetaStore } from '~/stores/meta.store'

export function useMetaData() {
  const config = useRuntimeConfig()
  const brandName = config.public.BRAND_NAME
  const indirectBrandName = config.public.INDIRECT_BRAND_NAME
  const indirectBrand2Name = config.public.INDIRECT_BRAND2_NAME
  const metaData = META_TITLES(brandName, indirectBrandName, indirectBrand2Name)
  const metaDescription = META_DESCRIPTION(brandName, indirectBrandName, indirectBrand2Name)
  const route = useRoute()
  const metaStore = useMetaStore()

  const isNewsDetails = computed(() => {
    return route.path.includes('.html')
  })

  const title = computed(() => {
    try {
      if (metaStore.title && isNewsDetails.value) {
        return metaStore.title
      }
      const routeName = route.name === 'slug' ? (route.params.slug as string) : (route.name as string)
      const tabActive: string =
        Object.values(route.query)
          .filter(item => item)
          .join('-') || 'default'
      if (Object.values(route.query).length === 0) {
        if (metaData[routeName] === undefined) {
          return metaData.default
        } else {
          return typeof metaData[routeName] === 'object'
            ? metaData[routeName].default ?? metaData.default
            : metaData[routeName] ?? metaData.default
        }
      }
      if (metaData[routeName] !== undefined) {
        return (metaData[routeName] as Record<string, string>)[tabActive]
      } else {
        return metaData.default
      }
    } catch {
      return metaData.default
    }
  })

  const description = computed(() => {
    try {
      if (metaStore.description && isNewsDetails.value) {
        return metaStore.description
      }
      const routeName = route.name === 'slug' ? (route.params.slug as string) : (route.name as string)
      const tabActive: string =
        Object.values(route.query)
          .filter(item => item)
          .join('-') || 'default'
      if (Object.values(route.query).length === 0) {
        if (metaDescription[routeName] === undefined) {
          return metaDescription.default
        } else {
          return typeof metaDescription[routeName] === 'object'
            ? metaDescription[routeName]?.default ?? metaDescription.default
            : metaDescription[routeName] ?? metaDescription.default
        }
      }
      return metaDescription[routeName] !== undefined
        ? (metaDescription[routeName] as Record<string, string>)[tabActive]
        : metaDescription.default
    } catch {
      return metaDescription.default
    }
  })
  return {
    title,
    description
  }
}
